import React from "react";
import socialMediaNews1 from "../../../../../assets/images/NewsRoomImages/newsImage3.png";
import socialMediaNews2 from "../../../../../assets/images/NewsRoomImages/Food Logistics.png";
import socialMediaNews3 from "../../../../../assets/images/NewsRoomImages/newsImage4.svg";
import socialMediaNews4 from "../../../../../assets/images/NewsRoomImages/socialMediaNews4.svg";
import {
  Container,
  Wrapper,
  Box,
} from "web/pages/public/landing-page/NewsRoom/SocialMediaNews/SocialMediaNewsStyled";

const socialNewsData = [
  {
    id: 1,
    socialImg: socialMediaNews1,
    socialHeader: "“Best in show demo winners!”",
    socialPara: "See the LinkedIn post",
    socialUrl:
      "https://www.linkedin.com/posts/freightwaves_best-in-show-demo-winners-day-1-denim-activity-6993984322856779776-tyyR/?utm_source=share&utm_medium=member_desktop",
  },
  {
    id: 2,
    socialImg: socialMediaNews2,
    socialHeader:
      "“PalletTrader enables and streamlines the #digitaltrading and sale of pallets…”",
    socialPara: "See the tweet",
    socialUrl: "https://twitter.com/FoodLogistics/status/1587836364162469888",
  },
  {
    id: 3,
    socialImg: socialMediaNews3,
    socialHeader:
      "“Built exclusively for the sourcing, buying and selling of commercial wooden pallets…”",
    socialPara: "See the tweet",
    socialUrl:
      "https://twitter.com/PalletEnterpris/status/1592684082986721280?s=20&t=MxNsdbkG-50Ku8nwSkmPCA",
  },
  {
    id: 4,
    socialImg: socialMediaNews4,
    socialHeader: "“…very excited to be a part of PalletTrader.”",
    socialPara: "See the LinkedIn post",
    socialUrl:
      "https://www.linkedin.com/posts/tri-pac_if-youre-a-pallet-buyer-you-need-to-be-activity-6986022982984876033-FUPn/?utm_source=share&utm_medium=member_desktop",
  },
];

const SocialMediaNews = () => {

  return (
    <Container>
      <Wrapper>
        {socialNewsData.map((e) => {
          return (
            <Box
              style={{ background: e.id % 2 === 0 ? `#95cce9` : `#095587` }}
              key={e.id}
            >
              <a href={e.socialUrl} target="_blank" rel="noopener noreferrer">
                <img
                  src={e.socialImg}
                  alt="Revolutionary"
                  style={{
                    padding: e.id === 2 ? "10px" : "0px",
                  }}
                />
              </a>
              <div className="text-section">
                <h4>{e.socialHeader}</h4>
                <a className="link" href={e.socialUrl} target="_blank" rel="noopener noreferrer">
                  {e.socialPara}
                </a>
              </div>
            </Box>
          );
        })}
      </Wrapper>
    </Container>
  );
};

export default SocialMediaNews;
